import React from "react";
import UsersCommon from "../UsersMain";

const DashboardUsers = () => {
  const type = "Recent_Signups";
  const title = "Recent Signups";
  const page = "Dashboard";

  return <UsersCommon type={type} title={title} page={page} />;
};

export default DashboardUsers;

